import { gql } from '@apollo/client'

export const recommendedQuantitiesToHitDeliveryDate = gql`
    query RecommendedQuantitiesToHitDeliveryDate(
        $quoteId: UUID!
        $currentEstimatedDeliveryDate: Date!
        $desiredDeliveryDate: Date
    ) {
        recommendedQuantitiesToHitDeliveryDate(
            quoteId: $quoteId
            currentEstimatedDeliveryDate: $currentEstimatedDeliveryDate
            desiredDeliveryDate: $desiredDeliveryDate
        ) {
            quoteModelRevisionId
            qty
            success
        }
    }
`
